import { isNumber } from '@doltech/utils/lib/number';
import { types } from 'mobx-state-tree';

import { defaultCorrectAnswer } from '../../../constants';
import { AdminAbstractQuestion } from '../admin-abstract-question.store';
import { AdminBlankCorrectAnswer } from '../CorrectOption/_extends/admin-blank-correct-answer.store';

export const generateBlankCorrectAnswer = (options: any) => ({
  ...defaultCorrectAnswer,
  ...options,
});


export const AdminAbstractQuestionWithBlankCorrectAnswers = AdminAbstractQuestion.named(
  'AdminAbstractQuestionWithBlankCorrectAnswers',
)
  .props({
    correctAnswers: types.array(AdminBlankCorrectAnswer),
  })
  .actions((self: any) => {
    const correctKey = () => {
      self.correctAnswers.forEach((correctAnswer: any, index: number) => {
        correctAnswer.key = index;
      });
    };
    return {
      addCorrectAnswer(correctAnswer: { key: number; blankId: string }) {
        const { key } = correctAnswer || { key: undefined };
        const newCorrectAnswer = generateBlankCorrectAnswer(correctAnswer);
        if (isNumber(key)) {
          self.correctAnswers.splice(key, 0, newCorrectAnswer);
          self.currentCorrectionIndex = key;
        } else {
          self.correctAnswers.push(newCorrectAnswer);
          self.currentCorrectionIndex = self.correctAnswers.length - 1;
        }
        correctKey();
      },
      removeCorrectAnswerByIndex(index: number) {
        self.correctAnswers.splice(index, 1);
        // reset current correction index
        if (self.currentCorrectionIndex > self.correctAnswers.length - 1) {
          self.currentCorrectionIndex = index - 1 >= 0 ? index - 1 : 0;
        }
        correctKey();
      },
    };
  })
  .views((self) => {
    const { isDirtyFn } = self;

    const isDirty = () => self.correctAnswers.some((answer) => answer.isDirty) || isDirtyFn();
    const isCompleted = () =>
      self.correctAnswers.every((answer) => answer.isCompleted) && isDirtyFn();

    return {
      get isCompleted() {
        return isCompleted();
      },
      get isDirty() {
        return isDirty();
      },
      isDirtyFn() {
        return isDirty();
      },
      isCompletedFn() {
        return isCompleted();
      },
      get corrections() {
        return self.correctAnswers;
      },
      get explanationKeys() {
        return self.correctAnswers.map((correctAnswer: any) => ({
          key: correctAnswer.key,
          displayKey: correctAnswer.key + 1,
          answerValue: correctAnswer.value,
          answerKey: correctAnswer.key,
        }));
      },
    };
  });

